
import { Card, CardContent } from "@/components/ui/card";
import { Twitter, Linkedin, Globe } from "lucide-react";
import { UserProfile } from "./types";

interface ProfileViewProps {
  profile: UserProfile;
  isOwnProfile: boolean;
}

const ProfileView = ({ profile, isOwnProfile }: ProfileViewProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        {profile.bio ? (
          <p className="text-base mb-6">{profile.bio}</p>
        ) : (
          <p className="text-muted-foreground mb-6">
            {isOwnProfile ? "You haven't added a bio yet. Edit your profile to add one." : "This user hasn't added a bio yet."}
          </p>
        )}
        
        <h3 className="text-lg font-medium mb-4">Social Profiles</h3>
        
        <div className="space-y-3">
          {profile.twitter_url && (
            <a 
              href={profile.twitter_url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            >
              <Twitter className="h-5 w-5" />
              <span>Twitter</span>
            </a>
          )}
          
          {profile.linkedin_url && (
            <a 
              href={profile.linkedin_url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            >
              <Linkedin className="h-5 w-5" />
              <span>LinkedIn</span>
            </a>
          )}
          
          {profile.website_url && (
            <a 
              href={profile.website_url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
            >
              <Globe className="h-5 w-5" />
              <span>Website</span>
            </a>
          )}
          
          {!profile.twitter_url && !profile.linkedin_url && !profile.website_url && (
            <p className="text-muted-foreground">
              {isOwnProfile ? "You haven't added any social links yet. Edit your profile to add them." : "This user hasn't added any social links yet."}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileView;
